// extracted by mini-css-extract-plugin
export default {"footer":"LeaderboardFooter_footer__WJLP5","presenterModeLink":"LeaderboardFooter_presenterModeLink__3Epaf"};